import { render, staticRenderFns } from "./ok-footer.vue?vue&type=template&id=275c532e&scoped=true&"
import script from "./ok-footer.vue?vue&type=script&lang=js&"
export * from "./ok-footer.vue?vue&type=script&lang=js&"
import style0 from "./ok-footer.vue?vue&type=style&index=0&id=275c532e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c532e",
  null
  
)

export default component.exports